<template>
  <div>
    <v-form @submit.prevent="onSubmit" autocomplete="off">
      <v-container fluid class="px-0">
        <v-layout :[plano]="true" justify-center v-if="mostrarBuscador">
          <v-flex xs12 md2 v-if="!isRs">
            <v-select
              data-cy="tktDestino"
              :items="formConfigTicket.destinos"
              label="Destino"
              v-model="form.destino"
              :disabled="isRs"
              v-validate="'required'"
              name="destino"
              solo
              :error-messages="errors.first('destino')"
              @change="selectedDestino"
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs12 md2 v-if="!isRs">
            <v-select
              :items="formConfigTicket.atracciones"
              label="Atracción"
              v-model="form.breve"
              v-validate="'required'"
              name="atraccion"
              solo
              :disabled="disabledAtraccion"
              :error-messages="errors.first('atraccion')"
              clearable
              class="tktAtraccion"
              id="atraccion"
              @change="atraccionSelected"
            ></v-select>
          </v-flex>
          <v-flex xs12 md2>
            <v-menu
              ref="picker"
              v-model="picker"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Fecha de entrada"
                  persistent-hint
                  solo
                  v-on="on"
                  class="caption tktFecha"
                  v-validate="'required'"
                  name="fecha"
                  :error-messages="errors.first('fecha')"
                  id="fechaTkt"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.checkin"
                no-title
                @input="parseDate"
                name="fecha"
                locale="es-AR"
                :min="formConfigTicket.startDate"
                :max="formConfigTicket.endDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md2>
            <v-select
              :items="formConfigTicket.dias"
              label="Cantidad de días"
              :value="5"
              v-model="form.dias"
              v-validate="'required'"
              name="dias"
              solo
              :error-messages="errors.first('dias')"
              :disabled="!seleccionaDias"
              class="tktDias"
              id="tktDias"
              @change="diasSelected"
            ></v-select>
          </v-flex>
          <v-flex xs12 md2 v-if="!isRs">
            <v-select
              :items="formConfigTicket.adultos"
              label="Adultos"
              v-model="form.adl"
              :disabled="isRs"
              v-validate="'required'"
              name="adultos"
              solo
              :error-messages="errors.first('adultos')"
              class="tktAdl"
              id="tktAdl"
              @change="aldsSelected"
            ></v-select>
          </v-flex>
          <v-flex xs12 md1 v-if="!isRs">
            <v-select
              :items="formConfigTicket.ninios"
              label="Niños"
              :hint="form.chd === null ? '3 a 9 ños' : 'Menores 3 a 9 ños'"
              persistent-hint
              v-model="form.chd"
              :disabled="isRs"
              v-validate="'required'"
              name="menores"
              solo
              :error-messages="errors.first('menores')"
              class="tktChd"
              id="tktChd"
            ></v-select>
          </v-flex>
          <v-flex xs12 md1 d-flex>
            <v-btn
              color="primary"
              type="submit"
              dark
              large
              class="mt-0"
              style="height: 48px;"
              data-cy="submitBusquedaTkt"
              >Buscar</v-btn
            >
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center row fill-height>
          <v-flex xs12 v-if="msgSinDispo">
            <v-alert :value="true" type="warning" outline class="text-sm-center"
              >No se encotraron tickets para su búsqueda.</v-alert
            >
          </v-flex>
          <v-flex xs12 v-if="buscando">
            <v-progress-linear
              indeterminate
              color="red"
              class="mb-0"
              height="1"
              v-if="buscando"
            ></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center row fill-height>
          <v-flex xs12 sm3 v-for="(t, tinx) in ticketsHab" :key="tinx">
            <PanelPase :pase="prepararToPanel(t)"></PanelPase>
          </v-flex>
        </v-layout>
        <v-layout
          align-center
          justify-center
          row
          fill-height
          v-if="tickets.length > 0"
        >
          <ContenedorRsPasesSinBuscador
            :data="{ pases: tickets }"
          ></ContenedorRsPasesSinBuscador>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import moment from "moment";
import PanelPase from "@/components/pases/PanelPase.vue";
import ContenedorRsPasesSinBuscador from "@/components/pases/ContenedorRsPasesSinBuscador.vue";
import AxiosHandler from "@/assets/js/class/AxiosHandler.js";
import RqHoteles from "@/assets/js/class/RqHoteles.js";
export default {
  name: "buscadorPases",
  props: {
    data: Object,
    plano: {
      validator: function(value) {
        return value;
      }
    },
    soloTickets: {
      type: Boolean,
      default: false
    },
    mostrarBuscador: {
      type: Boolean,
      default: true
    },
    isAsync: {
      type: Boolean,
      default: true
    },
    ticketTipo: {
      type: Number,
      default: 1
    },
    inicialIsRs: Boolean,
    proveedor: {
      type: String,
      default: "6156"
    },
    enfocar: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PanelPase,
    ContenedorRsPasesSinBuscador
  },
  mounted() {
    //  this.verJson(this.data);
    this.prepararForm();
  },
  created() {
    if (this.data != null) {
      this.preparar(this.data);
    }
  },
  methods: {
    parseDate(date) {
      let checkin = moment(date);
      this.dateFormatted = checkin.format("DD-MM-YYYY");
      this.form.checkin = checkin.format("YYYY-MM-DD");
      this.picker = false;
      let toclick = "tktDias";
      if (this.form.breve != "DISNEY") {
        toclick = "tktAdl";
      }
      if (this.enfocar) {
        setTimeout(function() {
          document.getElementById(toclick).click();
        }, 10);
      }
    },
    preparar(data) {
      this.ticketsHab = this.toArray(data.rs)[0].tickets;
      if (this.ticketsHab.length == 0) {
        return;
      }
      this.parseDate(this.ticketsHab[0].in);
      this.form.adl = parseInt(
        this.ticketsHab[0].tarifas.totales["@attributes"].adl
      );
      this.form.chd = parseInt(
        this.ticketsHab[0].tarifas.totales["@attributes"].chd
      );
      this.form.dias = data.rs[0].valor;
      this.form.codigo = data.regimen;
      this.form.destino = "z-379936";
      this.form.proveedor = this.proveedor;
      this.isRs = true;
    },
    onSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.getTickets();
        }
      });
    },
    armarRq() {},
    getTickets() {
      this.tickets = [];
      this.ticketsHab = [];
      if (!this.soloTickets) {
        this.getTickets2Habitaciones();
        return;
      }
      this.getTicketsSolos();
    },
    async getTickets2Habitaciones() {
      this.msgSinDispo = false;
      this.buscando = true;
      var header = this.$passporthandler.prepareHeader();
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" });
      }
      let axios = new AxiosHandler();
      axios.setPassportHandler(this.$passporthandler);
      let rq = this.form;
      if (this.isRs) {
        rq = [this.form];
      }
      axios.prepare(process.env.VUE_APP_ASBACK + "/api/get-pases", header, rq);
      axios.overlay(false);
      await axios.exe();
      this.manenoJsTickets(axios.getData(), axios.getStatus());
    },
    getTicketsSolos() {
      if (this.isAsync) {
        this.getTicketsSolosAsync();
        return;
      }
      this.getTicketsSolosReDirect();
    },
    async getTicketsSolosAsync() {
      this.msgSinDispo = false;
      this.buscando = true;
      var header = this.$passporthandler.prepareHeader();
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" });
      }
      let axios = new AxiosHandler();
      axios.setPassportHandler(this.$passporthandler);
      let rq = this.form;
      axios.prepare(process.env.VUE_APP_ASBACK + "/api/get-pases", header, rq);
      axios.overlay(false);
      await axios.exe();
      this.manenoJsTicketsAsync(axios.getData(), axios.getStatus());
    },
    getTicketsSolosReDirect() {
      let hand = new RqHoteles(this.form);
      this.$store.dispatch("app/setFormSaveTicket", this.form);
      const rq = hand.armarParametros2EsperaTicket(
        this.$router.currentRoute.name,
        "No se encontraron pases, será redirigido al buscador",
        "resultadoPases",
        "resultadoPases"
      );
      this.$router.replace({ name: "buscandox", params: { data: rq } });
    },
    manenoJsTickets(rs, status) {
      this.buscando = false;
      if (this.data != undefined) {
        this.manejoRsTicketHabitacion(rs);
        return;
      }
      this.manejoRsPasesAdicionales(rs);
    },
    manejoRsTicketHabitacion(rs) {
      if (rs.disponibilidad.length == 0) {
        this.msgSinDispo = true;
        return;
      }
      this.ticketsHab = rs.disponibilidad[0].rs[0].tickets;
    },
    selectedDestino(seleccionado) {
      this.form.breve = null;
      this.form.dias = null;
      this.formConfigTicket.atracciones = [];
      let destino = this.formConfigTicket.destinos.find(
        d => d.value === seleccionado
      );
      let toclick = "atraccion";
      if (seleccionado != "MCO") {
        toclick = "fechaTkt";
      }
      if (destino == undefined) {
        return;
      }
      if (this.enfocar) {
        setTimeout(function() {
          document.getElementById(toclick).click();
        }, 10);
      }
      console.log(destino.atracciones);
      this.formConfigTicket.atracciones = destino.atracciones;
    },
    manejoRsPasesAdicionales(rs) {
      this.tickets = rs.disponibilidad.ticket;
    },
    prepararToPanel(pase) {
      let data = {};
      data["pase"] = pase;
      if (this.data != undefined) {
        data["comparador"] = this.data.comparador;
      }
      return data;
    },
    manenoJsTicketsAsync(rs, status) {
      // PENDEITE VALIDACION DE STATUS
      this.buscando = false;
      this.tickets = rs.disponibilidad;
    },
    prepararForm() {
      const formSaved = this.$store.getters["app/getFormSavedTicket"];
      if (formSaved === null) {
        return;
      }
      this.selectedDestino(formSaved.destino); // Debe estar antes que destino y breve
      this.form = JSON.parse(JSON.stringify(formSaved));
      this.parseDate(formSaved.checkin);
    },
    atraccionSelected() {
      if (this.enfocar) {
        document.getElementById("fechaTkt").click();
      }
    },
    aldsSelected() {
      if (this.enfocar) {
        document.getElementById("tktChd").click();
      }
    },
    diasSelected() {
      if (this.enfocar) {
        document.getElementById("tktAdl").click();
      }
    }
  },
  data() {
    return {
      ticketsHab: [],
      tickets: [],
      picker: false,
      form: {
        checkin: moment()
          .add(5, "days")
          .format("YYYY-MM-DD"),
        dias: null,
        adl: null,
        chd: null,
        breve: null,
        codigo: null,
        desde: null,
        destino: null,
        proveedor: null,
        ticketTipo: this.ticketTipo
      },
      dateFormatted: null,
      isRs: this.inicialIsRs == undefined ? false : this.inicialIsRs,
      msgSinDispo: false,
      buscando: false,
      formConfigTicket: {
        startDate: moment()
          .add(5, "days")
          .format("YYYY-MM-DD"),
        endDate: moment()
          .add(365, "days")
          .format("YYYY-MM-DD"),
        destinos: [
          {
            text: "Orlando",
            value: "MCO",
            atracciones: [
              // { text: "Walt Disney World ", value: "DISNEY" },
              { text: "Universal Studios", value: "UNIVERSAL" },
              { text: "Icon Orlando", value: "ICON" },
              { text: "Madame Tussauds", value: "ORLANDOY" },
              { text: "Sea Life Orlando", value: "ORLANDOY" },
              { text: "Cena Show", value: "CENA" },
              { text: "Blue Man Group", value: "BMG" },
              { text: "Seaworld", value: "SEAWORLD" },
              { text: "Kennedy Space Center", value: "KSC" },
              { text: "Legoland", value: "LEGOLAND" },
              { text: "Busch Gardens", value: "BUSCH" },
              { text: "Discovery Cove", value: "DCOVE" },
              { text: "Cirque du Soleil", value: "CIRQUE" }
            ]
          },
          { text: "California", value: "DNY", atracciones: [] },
          { text: "Los Ángeles", value: "LAX", atracciones: [] },
          { text: "San Diego", value: "SAN", atracciones: [] },
          { text: "San Francisco", value: "SFO", atracciones: [] },
          { text: "Las Vegas", value: "LAS", atracciones: [] },
          { text: "París", value: "PAR", atracciones: [] }
        ],
        atracciones: [],
        dias: [
          { value: 1, text: "1 día" },
          { value: 2, text: "2 días" },
          { value: 3, text: "3 días" },
          { value: 4, text: "4 días" },
          { value: 5, text: "5 días" },
          { value: 6, text: "6 días" },
          { value: 7, text: "7 días" },
          { value: 8, text: "8 días" },
          { value: 9, text: "9 días" },
          { value: 10, text: "10 días" }
        ],
        adultos: [
          { value: 1, text: "1 adulto" },
          { value: 2, text: "2 Adultos" },
          { value: 3, text: "3 Adultos" },
          { value: 4, text: "4 Adultos" },
          { value: 5, text: "5 Adultos" },
          { value: 6, text: "6 Adultos" },
          { value: 7, text: "7 Adultos" },
          { value: 8, text: "8 Adultos" },
          { value: 9, text: "9 Adultos" },
          { value: 10, text: "10 Adultos" }
        ],
        ninios: [
          { value: 0, text: "0 menores" },
          { value: 1, text: "1 Niño" },
          { value: 2, text: "2 Niños" },
          { value: 3, text: "3 Niños" },
          { value: 4, text: "4 Niños" },
          { value: 5, text: "5 Niños" },
          { value: 6, text: "6 Niños" },
          { value: 7, text: "7 Niños" },
          { value: 8, text: "8 Niños" },
          { value: 9, text: "9 Niños" },
          { value: 10, text: "10 Niños" }
        ]
      }
    };
  },
  computed: {
    disabledAtraccion() {
      this.tickets = [];
      if (this.formConfigTicket.atracciones.length === 0) {
        this.form.breve = null;
        return true;
      }
      return false;
    },
    seleccionaDias() {
      if (this.form.breve === "DISNEY" || this.isRs) {
        return true;
      }
      return false;
    }
  }
};
</script>
